export const RECIPIENT_TYPE = {
  GROUP: 0,
  USER: 1,
};

export const RECIPIENT_TYPE_STRING = {
  GROUP: 'group',
  USER: 'user',
};

export const getRecipientType = (conversationType) => {
  return conversationType === 'dm' || conversationType === 'self_dm' || conversationType === 'user'
    ? RECIPIENT_TYPE.USER
    : RECIPIENT_TYPE.GROUP;
};

export const getRecipientTypeString = (recipientType) => {
  return recipientType === RECIPIENT_TYPE.USER 
    ? RECIPIENT_TYPE_STRING.USER 
    : RECIPIENT_TYPE_STRING.GROUP;
};

export const isGroupRecipient = (recipientType) => {
  return recipientType === RECIPIENT_TYPE.GROUP;
};

export const isUserRecipient = (recipientType) => {
  return recipientType === RECIPIENT_TYPE.USER;
};

export const buildMessageContext = (conversation) => {
  const isDM = conversation.type === 'dm' || conversation.type === 'self_dm' || conversation.type === 'user';
  
  return {
    recipient_type: isDM ? RECIPIENT_TYPE.USER : RECIPIENT_TYPE.GROUP,
    recipient_id: conversation.id || conversation.recipient_id,
    thread_id: conversation.currentThreadId || conversation.thread_id || null,
  };
};

export const buildRecipientParams = (recipientType, recipientId, threadId = null) => {
  const params = {
    recipient_type: recipientType,
    recipient_id: recipientId,
  };
  
  if (threadId) {
    params.thread_id = threadId;
  }
  
  return params;
};

export const getConversationKey = (recipientType, recipientId) => {
  const typeStr = getRecipientTypeString(recipientType);
  return `${typeStr}_${recipientId}`;
};
